import { useEffect, useState } from "react";
import { Flex, FlexColumn, SortUpArrow, SortDownArrow } from "../../styles/PairBoxStyles";
import Text from "../../utils/Text";


const SortButton = ({ text, onSortClicked, active }) => {

    const [sortActiveType, setSortActiveType] = useState("normal")

    const onSortButtonClicked = () => {
        if (sortActiveType === "normal") {
            setSortActiveType("up")
            onSortClicked(text, "up")
        } else if (sortActiveType === "up") {
            setSortActiveType("down")
            onSortClicked(text, "down")
        } else {
            setSortActiveType("normal")
            onSortClicked(text, "normal")
        }
    }

    useEffect(() => {
        if (!active) {
            setSortActiveType("normal")
        }
    }, [active])

    return (
        <Flex onClick={onSortButtonClicked}>
            <Text tid={text} />
            <FlexColumn>
                <SortUpArrow active={sortActiveType === "up" && active} />
                <SortDownArrow active={sortActiveType === "down" && active} />
            </FlexColumn>
        </Flex>
    )
}

export default SortButton;